<template>
  <div class="configuration-wizard-progress-bar text-xs font-bold mb-12">
    <div class="mb-2 h-1 w-full bg-gray-200 rounded overflow-hidden">
      <span
        class="block h-full bg-pink-500"
        :style="{width: progress}"
      />
    </div>
    <div class="flex flex-col sm:flex-row">
      <div
        v-for="(label, index) in labels"
        :key="index"
        class="flex-1"
        :class="{ 'text-gray-600' : !label.isActive, 'text-pink-300': label.isComplete}"
      >
        {{ label.name }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ConfigurationWizardProgressBar',

  props: {
    currentStep: {
      type: Number,
      required: true,
      default: 1,
    },

    labels: {
      type: Array,
      required: true,
    },
  },

  computed: {
    progress() {
      return `${(100 / this.labels.length * this.currentStep).toFixed(2)}%`;
    },
  },
};

</script>
